import { WagtailClient } from '~/api/wagtail.js'

export function useWagtailClient(preview, token, content_type, locale) {
  const config = useRuntimeConfig()
  const resolvedLocale = locale ?? 'de'
  const baseUrl = config.public.apiBase ?? ''
  const url = (false && config.serverApiBase)
    ? config.serverApiBase
    : baseUrl

  return new WagtailClient(url, preview, token, content_type, resolvedLocale, baseUrl)
}
